import { render, staticRenderFns } from "./account-menu.vue?vue&type=template&id=74bea292&scoped=true&"
import script from "./account-menu.vue?vue&type=script&lang=js&"
export * from "./account-menu.vue?vue&type=script&lang=js&"
import style0 from "./account-menu.vue?vue&type=style&index=0&id=74bea292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bea292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74bea292')) {
      api.createRecord('74bea292', component.options)
    } else {
      api.reload('74bea292', component.options)
    }
    module.hot.accept("./account-menu.vue?vue&type=template&id=74bea292&scoped=true&", function () {
      api.rerender('74bea292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/user-menu/account-menu.vue"
export default component.exports